const compareDates = (date1, date2) => new Date(date1) - new Date(date2);

const sortArrayOfObjectsByDateField = (array, field) =>
  [...array].sort((a, b) => compareDates(a[field], b[field]));

export default sortArrayOfObjectsByDateField;
